/** @jsxImportSource @emotion/react */
import { useTheme } from '@mui/material';
import { DataGrid, GridColDef, GridValueFormatterParams } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';

import { stripedDateGrid } from '../../../common/CustumEmotionStyles';
import { remToPixels } from '../../../common/CustomFunctions';
import { ISourceDocumentLineModel } from '../../../service/model/ISourceDocumentModel';
import { useTranslation } from 'react-i18next';

interface IProps {
    rows: ISourceDocumentLineModel[] | null | undefined,
    errors: string[],
}

const DatagridVoucherDoc = (props: IProps): JSX.Element => {

    const theme = useTheme();

    const [gridRows, setGridRows] = useState<any>([]);

    const { t } = useTranslation();

    useEffect(() => {

        let rows = props.rows ? props.rows.map(elem => {
            return {
                id: elem.id,
                invoiceNo: elem.invoiceNo,
                voucherDate: elem.voucherDate ? new Date(elem.voucherDate).toLocaleDateString("nb-NO") : "",
                dueDate: elem.dueDate ? new Date(elem.dueDate).toLocaleDateString("nb-NO") : "",
                amount: elem.amount,
                debitAccount: elem.debitAccount
                    ? `${elem.debitAccount.name || ""} (${elem.debitAccount.accountId || ""})`.trim()
                    : "",
                debitVat: elem.debitVat && (elem.debitVat.rate || elem.debitVat.vatCodeId)
                    ? `${elem.debitVat.rate || ""} (${elem.debitVat.vatCodeId || ""})`.trim()
                    : "",
                creditAccount: elem.creditAccount
                    ? `${elem.creditAccount.name || ""} (${elem.creditAccount.accountId || ""})`.trim()
                    : "", 
                creditVat: elem.creditVat && (elem.creditVat.rate || elem.creditVat.vatCodeId)
                    ? `${elem.creditVat.rate || ""} (${elem.creditVat.vatCodeId || ""})`.trim()
                    : "",
                department: elem.department ? elem.department.name + " (" + elem.department.departmentId + ")" : "",
                project: elem.project ? elem.project.name + " (" + elem.project.projectId + ")" : "",
                valueDate: elem.valueDate ? new Date(elem.valueDate).toLocaleDateString("nb-NO") : "",
                cid: elem.cid,
            }
        }) : [];

        setGridRows(rows)

    }, [props.rows])

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'id', width: 60, hide: true, },
        { field: 'invoiceNo', headerName: t('search.invoiceId'), width: 120, headerClassName: 'voucher-header-style' },
        { field: 'voucherDate', headerName: t('search.voucherDate'), width: 120, },
        { field: 'dueDate', headerName: t('search.dueDate'), width: 120, },
        {
            field: 'amount', headerName: t('search.amount'), width: 120, align:"right",
            valueFormatter: (params: GridValueFormatterParams<number>) => {
                if (params.value == null) {
                    return "";
                }
                return new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
            }
        },
        { field: 'debitAccount', headerName: t('search.debet'), width: 200 },
        { field: 'debitVat', headerName: t('search.debetVat'), width: 120 },
        { field: 'creditAccount', headerName: t('search.credit'), width: 200 },
        { field: 'creditVat', headerName: t('search.creditVat'), width: 120 },
        { field: 'department', headerName: t('search.department'), width: 170, },
        { field: 'project', headerName: t('search.project'), width: 170, },
        { field: 'valueDate', headerName: t('search.valueDate'), width: 120, },
        { field: 'cid', headerName: t('search.cid'), width: 250, },
    ];

    return <DataGrid css={stripedDateGrid(theme, theme.palette.grey[400])}
        rows={gridRows}
        columns={columns}
        rowHeight={remToPixels(2)}
        headerHeight={remToPixels(4)} hideFooter={true}
        getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        } />
}

export default DatagridVoucherDoc;